import { render, staticRenderFns } from "./Offset.vue?vue&type=template&id=a3dde496"
import script from "./Offset.vue?vue&type=script&lang=ts"
export * from "./Offset.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports